export default "__VITE_ASSET__nogMn$1o__"